/**
 * DocsPage - Container component for API documentation
 *
 * Manages documentation data and delegates UI to DocsPageView.
 * Handles loading states and API interactions.
 */
import { useState, useEffect } from 'react';
import { useSocket } from '../../shared/contexts/SocketContext';
import DocsPageView from './DocsPageView';
import { fetchDocumentation } from './documentation.api';
import type { DocumentationConfig } from './documentation.schema';

const DocsPage = () => {
  console.log('DocsPage is running');
  const [documentation, setDocumentation] = useState<DocumentationConfig | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const { addNotification } = useSocket();

  const loadDocumentation = async () => {
    setLoading(true);
    try {
      const docs = await fetchDocumentation();
      setDocumentation(docs);
      setError(null);
    } catch (err: any) {
      setError(err.message);
      addNotification({ type: 'error', message: err.message });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadDocumentation();
  }, []);

  console.log('DocsPage is returning documentation page');
  return <DocsPageView documentation={documentation} loading={loading} error={error} />;
};

export default DocsPage;
